var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeople = function SvgPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none",
    viewBox: "0 0 18 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11.88 12.76h4.54c.32 0 .58-.27.58-.59 0 0-.06-.88-.2-1.17-.16-.35-2.03-1.37-3.7-1.37-.97 0-2.01.35-2.74.7",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13.1 7.3a1.56 1.56 0 1 0 0-3.13 1.56 1.56 0 0 0 0 3.12Z",
    clipRule: "evenodd",
    vectorEffect: "non-scaling-stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6.46 9.72c-2.34 0-4.96 1.37-5.19 1.84-.18.39-.27 1.58-.27 1.58 0 .43.37.79.82.79h9.29a.8.8 0 0 0 .82-.8s-.1-1.18-.28-1.57c-.22-.47-2.85-1.84-5.19-1.84ZM6.46 7.2a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2Z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgPeople;